import { TDevicesDB, TBleModeInitDTO, TPairedDevice, TConnectedDeviceInfoParams } from '@monorepo/types';
import { Action } from '@ngrx/store';
import { TScanModes } from 'libs/services/src/lib/input-app/rfid-tag-reader.service';

export enum DevicesStoreActionTypes {
  AddBluetoothDevice = 'AddBluetoothDevice',
  RemoveBluetoothDevice = 'RemoveBluetoothDevice',
  RemoveAllDevices = 'RemoveAllDevices',
  DevicesStoreNoAction = 'DevicesStoreNoAction',
  InitDevicesStore = 'InitDevicesStore',
  SetDevicesStore = 'SetDevicesStore',
  UpdateConnectedDeviceInfo = 'UpdateConnectedDeviceInfo',
  UpdateRfidScanMode = 'UpdateRfidScanMode',
}

export class AddBluetoothDevice implements Action {
  readonly type = DevicesStoreActionTypes.AddBluetoothDevice;
  constructor(public deviceInfo: TPairedDevice) {}
}

export class InitDevicesStore implements Action {
  readonly type = DevicesStoreActionTypes.InitDevicesStore;
  constructor(public chainWithInitBleService?: TBleModeInitDTO) {}
}

export class SetDevicesStore implements Action {
  readonly type = DevicesStoreActionTypes.SetDevicesStore;
  constructor(public devicesDB: TDevicesDB, public chainWithInitBleService?: TBleModeInitDTO) {}
}

export class RemoveBluetoothDevice implements Action {
  readonly type = DevicesStoreActionTypes.RemoveBluetoothDevice;
  constructor(public deviceId: string) {}
}

export class RemoveAllDevices implements Action {
  readonly type = DevicesStoreActionTypes.RemoveAllDevices;
  constructor() {}
}

export class DevicesStoreNoAction implements Action {
  readonly type = DevicesStoreActionTypes.DevicesStoreNoAction;
  constructor() {}
}

export class UpdateRfidScanMode implements Action {
  readonly type = DevicesStoreActionTypes.UpdateRfidScanMode;
  constructor(public newScanMode: TScanModes) {}
}

export class UpdateConnectedDeviceInfo implements Action {
  readonly type = DevicesStoreActionTypes.UpdateConnectedDeviceInfo;
  constructor(public params: TConnectedDeviceInfoParams) {}
}

export type TDevicesStoreActions =
  | AddBluetoothDevice
  | RemoveBluetoothDevice
  | RemoveAllDevices
  | SetDevicesStore
  | UpdateConnectedDeviceInfo
  | UpdateRfidScanMode;
